"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregatedBudget = void 0;
const memoizee_1 = __importDefault(require("memoizee"));
class AggregatedBudget {
    constructor() {
        this.teamHours = 0;
        this.opsHours = 0;
        this.emHours = 0;
        this.bankHours = 0;
        this.items = {};
        this._getBankHours = (0, memoizee_1.default)((itemsKey) => {
            return Object.values(this.items).reduce((acc, budget) => {
                return acc + budget.getBankHours() || 0;
            }, 0);
        });
        this._getContractHours = (0, memoizee_1.default)((itemsKey) => {
            return Object.values(this.items).reduce((acc, budget) => {
                return acc + budget.getContractHours() || 0;
            }, 0);
        });
    }
    getItemsKey() {
        return Object.keys(this.items).sort().join(',');
    }
    add(customerId, budget) {
        if (!this.items[customerId]) {
            const total = (budget.emHours || 0) +
                (budget.opsHours || 0) +
                (budget.teamHours || 0) +
                (budget.getBankHours() || 0);
            if (total > 0) {
                this.emHours += budget.emHours || 0;
                this.opsHours += budget.opsHours || 0;
                this.teamHours += budget.teamHours || 0;
                this.bankHours += budget.getBankHours() || 0;
                this.items[customerId] = budget;
            }
        }
    }
    getTeamPlusOps() {
        return (this.teamHours || 0) + (this.opsHours || 0);
    }
    getPlannedHours() {
        return (this.teamHours || 0) + (this.opsHours || 0) + this.getBankHours();
    }
    getContractHours() {
        return this._getContractHours(this.getItemsKey());
    }
    getBankHours() {
        return this._getBankHours(this.getItemsKey());
    }
    filter(callback) {
        const filtered = new AggregatedBudget();
        Object.keys(this.items)
            .filter((id) => callback(id, this.items[id]))
            .forEach((id) => filtered.add(id, this.items[id]));
        return filtered;
    }
}
exports.AggregatedBudget = AggregatedBudget;
//# sourceMappingURL=AggregatedBudget.js.map